"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function BulbHue(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M17.35 8.166c-.13.28-.279.59-.43.95-1.08 2.48-1.78 4.27-2.229 6.22-.141.101-.58.38-1.691.49v-4.28c1.731-.41 3-1.85 3-3.55 0-.55-.45-1-1-1-.549 0-1 .45-1 1 0 .92-.9 1.67-2 1.67-1.099 0-2-.75-2-1.67 0-.55-.45-1-1-1-.549 0-1 .45-1 1 0 1.7 1.27 3.14 3 3.55v4.28c-1.11-.11-1.549-.389-1.69-.49-.449-1.95-1.149-3.74-2.23-6.22-.15-.36-.299-.67-.429-.95-.42-.88-.651-1.37-.651-2.24 0-1.02.3-1.31.401-1.41.599-.579 2.22-.539 3.929-.49.541.01 1.09.02 1.67.02.58 0 1.13-.01 1.67-.02 1.71-.049 3.33-.1 3.93.49.101.1.4.39.4 1.41 0 .87-.23 1.36-.65 2.24m-3.22 10.48c0 .03-.009.06-.009.09-.01.03-.01.07-.01.11v.9c-.301.11-.931.25-2.111.25-1.179 0-1.809-.14-2.11-.25v-.9c0-.04 0-.08-.01-.11-.04-.38-.09-.75-.139-1.1.589.14 1.33.23 2.259.23.93 0 1.67-.09 2.26-.23-.05.32-.09.66-.13 1.01m4.861-15.56c-1.201-1.18-3.141-1.12-5.37-1.06-.521.01-1.061.02-1.621.02-.559 0-1.099-.01-1.62-.02-2.24-.06-4.17-.12-5.37 1.06-.68.66-1.01 1.58-1.01 2.84 0 1.32.39 2.15.84 3.09.13.27.271.56.41.89 1.06 2.45 1.731 4.18 2.17 6.08.201.9.35 1.84.47 2.91v1.38c0 .17.04.33.12.48.25.46 1.101 1.24 3.99 1.24 2.451 0 3.43-.559 3.821-1.01.179-.19.29-.43.29-.71v-1.38c.12-1.07.269-2.01.469-2.91.44-1.9 1.111-3.63 2.17-6.08.14-.33.281-.62.411-.89.45-.94.839-1.77.839-3.09 0-1.26-.33-2.18-1.009-2.84", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = BulbHue;
